import { render } from "./CustomPercentage.vue?vue&type=template&id=39aaf452&scoped=true"
import script from "./CustomPercentage.vue?vue&type=script&lang=js"
export * from "./CustomPercentage.vue?vue&type=script&lang=js"

import "./CustomPercentage.vue?vue&type=style&index=0&id=39aaf452&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39aaf452"]])

export default __exports__